import { render } from "./CertificateOfCompletion.vue?vue&type=template&id=f0c80150&scoped=true"
import script from "./CertificateOfCompletion.vue?vue&type=script&lang=js"
export * from "./CertificateOfCompletion.vue?vue&type=script&lang=js"

import "./CertificateOfCompletion.vue?vue&type=style&index=0&id=f0c80150&scoped=true&lang=css"

import exportComponent from "/home/nick/GIT/hort-310-cutting-monitoring-simulation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c80150"]])

export default __exports__